import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  main: {
    borderBottom: '1px solid',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    height: 80,
    padding: '0 5vw',
  },
  containerLeft: {
    display: 'flex',
    gap: 48,
    alignItems: 'center',
  },
  containerRight: {
    display: 'flex',
    gap: 48,
    alignItems: 'center',
  },
  wrapperIconText: {
    gap: 8,
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
};

export const borderStyle = (color: string): React.CSSProperties => ({
  borderBottom: `0.3rem solid ${color}`,
  marginTop: '0.3rem',
});

export default styles;
